var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"so-course-list"},_vm._l((_vm.data.rows),function(document){return _c('so-course',{key:document.id,staticClass:"so-course-list__item",attrs:{"data":document,"extActionsMeta":_vm.actionsMeta}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }